import { memo, useMemo } from 'react';

import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import DebitCardPaymentRow from './DebitCardPaymentRow';

function ListDebitCardPayment({ payments, cardInfo }) {
  const paymentRows = useMemo(
    () =>
      payments.map(({ uuid, routineStatus, amount, createdDatetime, updatedDatetime }) => (
        <DebitCardPaymentRow
          amount={amount.formattedAmount}
          cardInfo={cardInfo}
          createdDatetime={createdDatetime}
          key={uuid}
          routineStatus={routineStatus}
          updatedDatetime={updatedDatetime}
          uuid={uuid}
        />
      )),
    [cardInfo, payments]
  );

  return (
    <Stack
      aria-label="List of payments"
      direction="column"
      paddingBottom="20px"
      role="list"
    >
      <Stack
        direction="column"
        spacing="16px"
      >
        <Text
          color="tertiary"
          size="xs"
        >
          History
        </Text>
        <Divider />
        <Stack
          direction="column"
          spacing="8px"
        >
          {paymentRows}
        </Stack>
      </Stack>
    </Stack>
  );
}

ListDebitCardPayment.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      routineStatus: PropTypes.string.isRequired,
      amount: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        formattedAmount: PropTypes.string.isRequired
      }).isRequired,
      createdDatetime: PropTypes.string,
      updatedDatetime: PropTypes.string
    })
  ).isRequired,
  cardInfo: PropTypes.shape({
    cardCompany: PropTypes.string,
    cardLastFourDigits: PropTypes.string,
    cardHolderFirstName: PropTypes.string,
    cardHolderLastName: PropTypes.string,
    cardBillingAddress: PropTypes.shape({
      address1: PropTypes.string,
      address2: PropTypes.string,
      state: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string
    })
  })
};

function areEqual(preProp, nextProp) {
  return preProp.payments === nextProp.payments && preProp.cardInfo === nextProp.cardInfo;
}

export default memo(ListDebitCardPayment, areEqual);
